/**
 * Handlebars helpers
 *
 * @author dkvistgaard <dkvistgaard@vertic.com>
 */

const _helpers = {};

/**
 * Various if or unless condition checks or operators.
 *
 * Usage examples:
 *
 * Checking if all three values are equal:
 * {{#if (eq value1 value2 value3)}} {{/if}}
 *
 * Checking if value1 === value2 OR value3 <= 500
 * {{#if (or (eq value1 value2) (lte value3 500))}}
 */

// Equal (value1 === value2 === ...)
_helpers.eq = (...values) => {
	// Removing options from values array
	values.splice(-1, 1);

	return values.every((value) => {
		return value === values[0];
	});
};

// Not equal (value1 !== value2 !== ...)
_helpers.ne = (...values) => {
	// Removing options from values array
	values.splice(-1, 1);

	return values.every((value, index) => {
		const valuesClone = values.slice();
		valuesClone.splice(index, 1);

		return valuesClone.indexOf(value) === -1;
	});
};

// "and" operator (value1 && value2 && ...)
_helpers.and = (...values) => {
	// Removing options from values array
	values.splice(-1, 1);

	return values.every((value) => {
		return !!value;
	});
};

// "or" operator (value1 || value2 || ...)
_helpers.or = (...values) => {
	// Removing options from values array
	values.splice(-1, 1);

	return values.some((value) => {
		return !!value;
	});
};

// Less than check (value1 < value2)
_helpers.lt = (value, check) => {
	return value < check;
};

// Greater than check (value1 > value2)
_helpers.gt = (value, check) => {
	return value > check;
};

// Less than or equal check (value1 <= value2)
_helpers.lte = (value, check) => {
	return value <= check;
};

// Greater than or equal check (value1 >= value2)
_helpers.gte = (value, check) => {
	return value >= check;
};

_helpers.getJsonContext = (data, options) => {
	return options.fn(JSON.parse(data));
};

// /end of various if or unless condition checks or operators.

module.exports = _helpers;
